"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleWatcher = void 0;
var useSingleWatcher_1 = require("../../hooks/useSingleWatcher");
var SingleWatcher = function (props) {
    (0, useSingleWatcher_1.useSingleWatcher)(props);
    return null;
};
exports.SingleWatcher = SingleWatcher;
